import uniq from 'lodash/uniq';
import objectValues from 'lodash/values';

/**
 * SectionRow []->[]
 *
 * Takes an array of seat map section rows
 * and returns the unique blocking codes
 * for the seats in the section.
 *
 * @param rows - Array
 * @returns {Array}
 * @author Fredrik Christenson <fredrik.christenson@ticnet.se>
 */
export const sectionRowsToBlockingCodes = function (rows) {
  return rows.map(function (row) {
    return row.seats; // we get the seats from the row
  })
  .reduce(function (acc, next) {
    return acc.concat(next); // now we have an nested array of seats we flatmap
  }, [])
  .map(function (seat) {
    return seat.blockingCode; // we get the blocking code from the seat
  })
  .reduce(function (acc, next) {
    if (acc.indexOf(next) === -1) { // if the blocking code is not already in our result we add it
      acc.push(next);
    }
    return acc;
  }, []);
};

/**
 * EventPrices {}->[]
 *
 * Takes the evenprices object and returns an array
 * of the unique blocking codes on the event.
 *
 * @param eventPrices - The event prices object that is provided in the event_prices store
 * @returns {Array}
 *
 * @author Fredrik Christenson <fredrik.christenson@ticnet.se>
 */
export const eventPricesToBlockingCodes = function (eventPrices) {
  var nestedCodes = objectValues(eventPrices.priceTypes) // we convert the priceTypes object to an array
    .map(function (priceType) {
      // we grab the blocking codes from each pricetype and if it is a pricetype without a blockingcode we add a 0 to
      // simulate no blockingcode for the availability parser in SIM
      return (priceType.blockingCodes.length > 0) ? priceType.blockingCodes : [0];
    });
  var result = Array.prototype.concat.apply([], nestedCodes); // we flatmap the nested array
  return uniq(result); // we return the unique blocking codes
};

export default { sectionRowsToBlockingCodes, eventPricesToBlockingCodes };



// WEBPACK FOOTER //
// ./frontend/react/utils/sim/blocking_code.js